import { render, staticRenderFns } from "./KeysetPagination.vue?vue&type=template&id=5ecb9e65&"
import script from "./KeysetPagination.vue?vue&type=script&lang=js&"
export * from "./KeysetPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports